import { VALIDATION_DISCOUNT_TYPE, VALIDATION_TYPE } from "../enums/Enums";
import Strings from "../resources/Strings";
import { convertUTCToLocalTime } from "./CommonUtils";
import { isRequired } from "./FormUtils";

export const getValidationHistoriesData = (usersData, rawValidationHistories, selectedSite, siteCurrencySymbol) => {
    let validationAmountSum = 0;

    // Converts first date according to the current site time zone as date object
    let firstDate = rawValidationHistories?.length > 0 ? new Date(new Date(convertUTCToLocalTime(rawValidationHistories?.[0]?.redeemTime))?.toLocaleString('en-US', { hour12: true, timeZone: selectedSite?.timeZone })) : null;
    let localMinDate = firstDate; 
    let localMaxDate = firstDate;

    // Arrange received data to table rows
    let validationHistories = rawValidationHistories.map(vh => {     
        let userDataForValidationHistory = usersData.find(user => user.utronUser.id === vh.userId);
        let validationAmount = `${siteCurrencySymbol}${vh.validationAmount}`;
        let validationDiscountType = VALIDATION_DISCOUNT_TYPE;
        let validationType = VALIDATION_TYPE;

        // handle charge account exists case
        let chargeAccountCopy = null;
        if (vh.chargeAccount !== null) {
          let userDataForChargeAccount = usersData.find(user => user.utronUser.id === vh.chargeAccount?.userId);
          chargeAccountCopy = { ...vh.chargeAccount };
          chargeAccountCopy.user = userDataForChargeAccount;
          chargeAccountCopy.user.utronUser.chargeAccount = vh.chargeAccount.name;
        }

        // if null / empty / undefined - show N/A
        let phoneNumber = isRequired(userDataForValidationHistory?.phoneNumber)?.isValid ? `+${userDataForValidationHistory?.phoneNumber}` : Strings.NOT_AVAILABLE;
        let email = isRequired(userDataForValidationHistory?.email)?.isValid ? userDataForValidationHistory?.email : Strings.NOT_AVAILABLE;

        validationAmountSum += vh.validationAmount;

        // Converts current date according to the current site time zone as date string
        let currentDateString = new Date(convertUTCToLocalTime(vh.redeemTime))?.toLocaleString('en-US', { hour12: true, timeZone: selectedSite?.timeZone });
        let currentDate = new Date(currentDateString); // set converted string as date object
        localMinDate = currentDate < localMinDate ? currentDate : localMinDate;
        localMaxDate = currentDate > localMaxDate ? currentDate : localMaxDate;
        
        // Map enums to the pre defined enum strings
        let mappedValidationEnumToString = Object.entries(validationDiscountType).map(arr => {
            let foundedKey = Object.entries(validationDiscountType).find(arr => arr[1] === vh.validationType)[0];
            if (arr[1] === vh.validationType) {
              return validationType[foundedKey];
            }
        }).filter(v => v)[0]; // Remove undefined and take first result

        // if charge account data exists, add on validation history obj as member
        let vhObj = {
            id: vh.id,
            ...(vh.chargeAccount !== null) && { chargeAccount: chargeAccountCopy },
            date: currentDateString, 
            validationAmount: validationAmount,
            validationType: mappedValidationEnumToString,
            phoneNumber: phoneNumber,
            email: email
        };

        return vhObj;
    });

    return {
        validationHistories: validationHistories,
        validationAmountSum: validationAmountSum,
        validationHistoriesCount: validationHistories?.length,
        minDate: localMinDate,
        maxDate: localMaxDate
    }
};

export const getTotalValidationAmount = (data) => {
  let validationAmountSum = 0;
  data.forEach((vh) => {
    validationAmountSum += parseFloat(vh.validationAmount.slice(1));
  });

  return validationAmountSum;
};